module.exports = __webpack_public_path__ + "img/12.03c38b33.jpg";